import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';

export const mapDataSetDependentsToDataSet = (
  dataSets: DataSet[],
): Record<
  string,
  {
    id: string;
    name: string;
  }[]
> => {
  const dataSetMap: Record<string, { id: string; name: string }[]> = {};

  for (const dataSet of dataSets) {
    if (dataSet.config.dataSetType === 'Composite') {
      for (const dependentDS of dataSet.config.taggedDataSetReferences) {
        const dependentDSID = dependentDS.dataSetReference.dataSetId;
        const currentList = dataSetMap[dependentDSID] || [];
        currentList.push({
          id: dataSet.id,
          name: dataSet.displayName,
        });
        dataSetMap[dependentDSID] = currentList;
      }
    } else if (
      dataSet.config.dataSetType === 'Integration' ||
      dataSet.config.dataSetType === 'File' ||
      dataSet.config.dataSetType === 'Supplemental'
    ) {
      continue;
    } else {
      throw guardExhaustive(dataSet.config);
    }
  }

  return dataSetMap;
};
